'use es6';

import { combineReducers } from 'redux';
import Immutable from 'immutable';
import * as RequestState from 'marketplace-ui-common/requestStates/RequestState';
import * as ActionTypes from '../actions/ActionTypes';
import { PAGE_KEY } from 'marketplace-ui-reviews/constants/ReviewsListQueries';
import * as ReviewTypes from 'marketplace-ui-reviews/constants/ReviewType';
import Review from 'marketplace-ui-reviews/records/Review';
import ReviewStats from 'marketplace-ui-reviews/records/ReviewStats';
import ReviewFilters from 'marketplace-ui-reviews/records/ReviewFilters';
const EMPTY_LIST = Immutable.List();
const listRequestState = (state = RequestState.UNINITIALIZED, action) => {
  switch (action.type) {
    case ActionTypes.REVIEWS_LIST_REQUESTED:
      return RequestState.PENDING;
    case ActionTypes.REVIEWS_LIST_RECEIVED:
      return RequestState.SUCCEEDED;
    case ActionTypes.REVIEWS_LIST_FAILED:
      return RequestState.FAILED;
    case ActionTypes.REVIEWS_LIST_RESET:
      return RequestState.UNINITIALIZED;
    default:
      return state;
  }
};
const list = (state = EMPTY_LIST, {
  type,
  payload
}) => {
  switch (type) {
    case ActionTypes.REVIEWS_LIST_RECEIVED:
      return new Immutable.List(Review.fromArray(payload.reviews, payload.reviewType));
    case ActionTypes.REVIEW_HELPFUL_RECEIVED:
      {
        const indexToUpdate = state.findIndex(review => review.get('id') === payload.reviewId);
        return state.update(indexToUpdate, review => review.toggleHelpful(payload.reviewId, payload.userId, payload.isHelpful));
      }
    case ActionTypes.REVIEWS_LIST_RESET:
      {
        return EMPTY_LIST;
      }
    default:
      return state;
  }
};
const total = (state = 0, {
  type,
  payload
}) => {
  switch (type) {
    case ActionTypes.REVIEWS_LIST_RECEIVED:
      return payload.total;
    default:
      return state;
  }
};
const statsRequestState = (state = RequestState.UNINITIALIZED, action) => {
  switch (action.type) {
    case ActionTypes.REVIEW_STATS_REQUESTED:
      return RequestState.PENDING;
    case ActionTypes.REVIEW_STATS_RECEIVED:
      return RequestState.SUCCEEDED;
    case ActionTypes.REVIEW_STATS_FAILED:
      return RequestState.FAILED;
    case ActionTypes.REVIEW_STATS_RESET:
    default:
      return state;
  }
};
const stats = (state = new ReviewStats(), {
  type,
  payload
}) => {
  switch (type) {
    case ActionTypes.REVIEW_STATS_RECEIVED:
      return new ReviewStats(payload).set('reviewType', ReviewTypes.THEME);
    case ActionTypes.REVIEW_STATS_RESET:
      {
        return new ReviewStats();
      }
    default:
      return state;
  }
};
const filters = (state = new ReviewFilters(), {
  type,
  payload
}) => {
  switch (type) {
    case ActionTypes.REVIEW_FILTERS_INITIALIZED:
      return new ReviewFilters({
        reviewTypes: [ReviewTypes.THEME],
        entityId: payload.entityId
      });
    case ActionTypes.REVIEW_FILTERS_UPDATED:
      {
        let newFilters = state.updateFilters(payload.updates);
        if (!payload.updates[PAGE_KEY]) {
          newFilters = newFilters.updateFilters({
            [PAGE_KEY]: 1
          });
        }
        return newFilters;
      }
    default:
      return state;
  }
};
const reviewSubmitted = (state = false, {
  type
}) => {
  switch (type) {
    case ActionTypes.REVIEW_WRITE_RECEIVED:
      return true;
    case ActionTypes.REVIEW_SUBMITTED_RESET:
      return false;
    default:
      return state;
  }
};
export default combineReducers({
  listRequestState,
  list,
  total,
  statsRequestState,
  stats,
  filters,
  reviewSubmitted
});